// MyMeetings Integration Configuration

export const MYMEETINGS_CONFIG = {
  // Set to true to use mock client (for development before MyMeetings is deployed)
  USE_MOCK: process.env.VITE_MYMEETINGS_USE_MOCK === 'true' || !process.env.VITE_MYMEETINGS_API_URL,
  
  // API URLs
  API_URL: process.env.VITE_MYMEETINGS_API_URL || 'https://api.mymeetings.com/v1',
  AUTH_URL: process.env.VITE_MYMEETINGS_AUTH_URL || 'https://auth.mymeetings.com',
  
  // OAuth Configuration (these can be dummy values in mock mode)
  CLIENT_ID: process.env.VITE_MYMEETINGS_CLIENT_ID || 'mock-client-id',
  CLIENT_SECRET: process.env.VITE_MYMEETINGS_CLIENT_SECRET || 'mock-client-secret',
  REDIRECT_URI: process.env.VITE_MYMEETINGS_REDIRECT_URI || `${window.location.origin}/portal/admin/integrations/mymeetings/callback`,
  
  // Feature Flags
  ENABLE_WEBHOOKS: process.env.VITE_MYMEETINGS_ENABLE_WEBHOOKS === 'true',
  ENABLE_TWO_WAY_SYNC: process.env.VITE_MYMEETINGS_ENABLE_TWO_WAY_SYNC === 'true',
  
  // Sync Configuration
  DEFAULT_SYNC_FREQUENCY: 'hourly' as const,
  MAX_SYNC_BATCH_SIZE: 100,
  SYNC_TIMEOUT_MS: 5 * 60 * 1000, // 5 minutes
  
  // Rate Limiting
  API_RATE_LIMIT_PER_MINUTE: 100,
  WEBHOOK_RATE_LIMIT_PER_MINUTE: 1000,
}

// Helper to check if we're in mock mode
export const isMyMeetingsMockMode = () => MYMEETINGS_CONFIG.USE_MOCK

// Helper to get display-friendly mode
export const getMyMeetingsMode = () => isMyMeetingsMockMode() ? 'Mock/Development' : 'Production'